createjs.Ticker.framerate = 60;
export default createjs;